// 用于二次开发的快速扩展封装

import MethodsModel from './methodsModel';

// let fastExtend = new MethodsModel();

export default MethodsModel;

// demo 在价格调整单